<template>
  <v-dialog v-model="dialog" scrollable max-width="600px" persistent overlay-opacity="0.85" content-class="test">
    <v-card>
      <v-card-title class="pr-2" :style=" { backgroundColor: companyPrimaryColor }">
        <h2 style="color:white">Haarconditie bepalen</h2>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="closeAddMedicalIntakeDialog()" :disabled="uploading">
          <v-icon dark color="white">close</v-icon>
        </v-btn>
      </v-card-title>

      <div class="hogans-alerts">
        <v-alert
          v-if="feedback"
          :value="true"
          type="warning"
        >
        {{ feedback }} 
        </v-alert>
      </div>

      <v-divider></v-divider>

      <v-card-text class="py-2">
        <v-form ref="AddClientQueueForm" v-model="valid" lazy-validation>
          <div v-if="step == 1">
            <v-container grid-list-md class="ma-0 pa-2" fluid>
              <v-layout row wrap class="py-2">
                <v-flex xs12>
                  <h2>Wij willen je graag een aantal vragen stellen om je huidige conditie van je haar te bepalen.</h2>
                  <p class="pt-2"><i>Voor een juist advies en behandeling van hairextensions, is het noodzakelijk om een aantal gegevens te
                    registreren. Die gegevens staan hieronder vermeld. Door het invullen en ondertekenen van deze
                    vragenlijst, geef je uitdrukkelijk toestemming aan ons om deze gegevens te registreren. Deze gegevens
                    worden niet gebruikt voor een ander doel dan hiervoor is aangegeven, namelijk een juist advies en
                    behandeling voor hairextensions. Deze gegevens zijn alleen voor intern gebruik en worden niet met
                    anderen gedeeld.</i></p>
                    <v-divider></v-divider>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="py-2">
                <v-flex md7 xs12>
                  <label>1. Hoe vaak kleur je helemaal je haar per jaar?</label>
                </v-flex>
                <v-flex md5 xs12>
                  <v-select
                    v-model="newMedicalIntake.questions.colorTimesYear"
                    :items="colorTimesYear"
                    item-text="name"
                    item-value="id"
                    outlined
                    dense
                    required
                    hide-details
                    :rules="requiredRules"
                    :disabled="type == 'view'"
                  ></v-select> 
                </v-flex>
              </v-layout>

              <v-layout row wrap style="background-color: #f1f1f1;" class="py-2">
                <v-flex md8 xs12>
                  <label>2. Heb je het afgelopen jaar je haar geblondeerd?</label>
                </v-flex>
                <v-flex md4 xs12>
                  <v-radio-group v-model="newMedicalIntake.questions.bleachedLastYear" class="ma-0 pa-0" hide-details row  :disabled="type == 'view'">
                    <v-radio label="Ja" value="yes"></v-radio>
                    <v-radio label="Nee" value="no"></v-radio>
                  </v-radio-group>
                </v-flex>
              </v-layout>

              <v-layout row wrap class="py-2">
                <v-flex md8 xs12>
                  <label>3. Ben je de laatste 3 maanden meer dan 10 kilo afgevallen? Of ben je momenteel op dieet of doe je aan intermittent fasting?</label>
                </v-flex>
                <v-flex md4 xs12>
                  <v-radio-group v-model="newMedicalIntake.questions.recentWeightloss" class="ma-0 pa-0 pt-2" hide-details row  :disabled="type == 'view'">
                    <v-radio label="Ja" value="yes"></v-radio>
                    <v-radio label="Nee" value="no"></v-radio>
                  </v-radio-group>
                </v-flex>
              </v-layout>

              <v-layout row wrap style="background-color: #f1f1f1;" class="py-2">
                <v-flex md8 xs12>
                  <label>4. Ervaar je momenteel meer stress dan normaal?</label>
                </v-flex>
                <v-flex md4 xs12>
                  <v-radio-group v-model="newMedicalIntake.questions.stress" class="ma-0 pa-0" hide-details row  :disabled="type == 'view'">
                    <v-radio label="Ja" value="yes"></v-radio>
                    <v-radio label="Nee" value="no"></v-radio>
                  </v-radio-group>
                </v-flex>
              </v-layout>

              <v-layout row wrap class="py-2">
                <v-flex md8 xs12>
                  <label>5. Ben je de laatste 3 maanden medicijnen gaan gebruiken? Of ga je binnenkort medicijnen gebruiken?</label>
                </v-flex>
                <v-flex md4 xs12>
                  <v-radio-group v-model="newMedicalIntake.questions.medicines" class="ma-0 pa-0 pt-2" hide-details row  :disabled="type == 'view'">
                    <v-radio label="Ja" value="yes"></v-radio>
                    <v-radio label="Nee" value="no"></v-radio>
                  </v-radio-group>
                </v-flex>
              </v-layout>

              <v-layout row wrap class="py-2" style="background-color: #f1f1f1;" >
                <v-flex md8 xs12>
                  <label>6. Hebben deze medicijnen <u>haarverlies</u> als bijwerking?</label>
                </v-flex>
                <v-flex md4 xs12>
                  <v-radio-group v-model="newMedicalIntake.questions.medicinHairloss" class="ma-0 pa-0" hide-details row  :disabled="type == 'view'">
                    <v-radio label="Ja" value="yes"></v-radio>
                    <v-radio label="Nee" value="no"></v-radio>
                    <v-radio label="Weet ik niet" value="dontknow"></v-radio>
                  </v-radio-group>
                </v-flex>
              </v-layout>

              <v-layout row wrap class="py-2">
                <v-flex md8 xs12>
                  <label>7. Ben je recent onder narcose geweest?</label>
                </v-flex>
                <v-flex md4 xs12>
                  <v-radio-group v-model="newMedicalIntake.questions.narcose" class="ma-0 pa-0" hide-details row  :disabled="type == 'view'">
                    <v-radio label="Ja" value="yes"></v-radio>
                    <v-radio label="Nee" value="no"></v-radio>
                  </v-radio-group>
                </v-flex>
              </v-layout>

              <v-layout row wrap class="py-2">
                <v-flex md8 xs12>
                  <label>8. Ben je net bevallen of gestopt met het geven borstvoeding?</label>
                </v-flex>
                <v-flex md4 xs12>
                  <v-radio-group v-model="newMedicalIntake.questions.recentBirth" class="ma-0 pa-0 pt-2" hide-details row  :disabled="type == 'view'">
                    <v-radio label="Ja" value="yes"></v-radio>
                    <v-radio label="Nee" value="no"></v-radio>
                  </v-radio-group>
                </v-flex>
              </v-layout>

              <v-layout row wrap class="py-2" style="background-color: #f1f1f1;">
                <v-flex md6 xs12>
                  <label>9. Indien je nu zwanger bent, wanneer is je uitgerekende datum?</label>
                </v-flex>
                <v-flex md6 xs12>
                  <v-select
                    v-model="newMedicalIntake.questions.periodGiveBirth"
                    :items="periodGiveBirthOptions"
                    item-text="name"
                    item-value="id"
                    outlined
                    dense
                    required
                    hide-details
                    :rules="requiredRules"
                    :disabled="type == 'view'"
                  ></v-select> 
                </v-flex>
              </v-layout>

              <v-layout row wrap class="py-2" style="background-color: #f1f1f1;" >
                <v-flex md8 xs12>
                  <label>10. Heb je de laatste 3 maanden last van andere hormoonschommelingen gehad: zoals een verandering in je anticonceptie, menopauze of hormonenkuur?</label>
                </v-flex>
                <v-flex md4 xs12>
                  <v-radio-group v-model="newMedicalIntake.questions.hormoneFluctuations" class="ma-0 pa-0 pt-2" hide-details row  :disabled="type == 'view'">
                    <v-radio label="Ja" value="yes"></v-radio>
                    <v-radio label="Nee" value="no"></v-radio>
                  </v-radio-group>
                </v-flex>
              </v-layout>

              <v-layout row wrap class="py-2">
                <v-flex md8 xs12>
                  <label>11. Heb je in het verleden last gehad van zichtbaar haaruitval of kaalheid?</label>
                </v-flex>
                <v-flex md4 xs12>
                  <v-radio-group v-model="newMedicalIntake.questions.boldness" class="ma-0 pa-0 pt-2" hide-details row  :disabled="type == 'view'">
                    <v-radio label="Ja" value="yes"></v-radio>
                    <v-radio label="Nee" value="no"></v-radio>
                  </v-radio-group>
                </v-flex>
              </v-layout>

              <v-layout row wrap class="py-2" style="background-color: #f1f1f1;">
                <v-flex md8 xs12>
                  <label>12. Lijd je aan één van de volgende haar aandoeningen of heb je daar in het verleden last van gehad: Alopecia androgenetica, Alopecia areata, Telogeen effluvium.</label>
                </v-flex>
                <v-flex md4 xs12>
                  <v-radio-group v-model="newMedicalIntake.questions.diseases" class="ma-0 pa-0 pt-2" hide-details row  :disabled="type == 'view'">
                    <v-radio label="Ja" value="yes"></v-radio>
                    <v-radio label="Nee" value="no"></v-radio>
                  </v-radio-group>
                </v-flex>
              </v-layout>

              <v-layout row wrap class="py-2">
                <v-flex md8 xs12>
                  <label>13. Heb je het afgelopen half jaar haaruitval door Corona gehad?</label>
                </v-flex>
                <v-flex md4 xs12>
                  <v-radio-group v-model="newMedicalIntake.questions.corona" class="ma-0 pa-0 pt-2" hide-details row  :disabled="type == 'view'">
                    <v-radio label="Ja" value="yes"></v-radio>
                    <v-radio label="Nee" value="no"></v-radio>
                  </v-radio-group>
                </v-flex>
              </v-layout>

              <v-layout row wrap class="py-2" style="background-color: #f1f1f1;">
                <v-flex md8 xs12>
                  <label>14. Hoe oud ben je?</label>
                </v-flex>
                <v-flex md4 xs12>
                  <v-select
                    v-model="newMedicalIntake.questions.age"
                    :items="ageOptions"
                    item-text="name"
                    item-value="id"
                    outlined
                    dense
                    required
                    hide-details
                    :rules="requiredRules"
                    :disabled="type == 'view'"
                  ></v-select> 
                </v-flex>
              </v-layout>

              <v-layout row wrap class="py-2">
                <v-flex md8 xs12>
                  <label>15. Ben vegetarisch of veganistisch?</label>
                </v-flex>
                <v-flex md4 xs12>
                  <v-radio-group v-model="newMedicalIntake.questions.vega" class="ma-0 pa-0 pt-2" hide-details row  :disabled="type == 'view'">
                    <v-radio label="Ja" value="yes"></v-radio>
                    <v-radio label="Nee" value="no"></v-radio>
                  </v-radio-group>
                </v-flex>
              </v-layout>




            </v-container>
          </div>

          <div v-if="step == 2" >

            <div v-if="!selectedFromDossier && type =='add' && !client" class="pa-2" >

              <h3>Zoek klant in Salonhub</h3>
              <v-text-field
                dense
                outlined
                :color="companyPrimaryColor"
                :background-color="$vuetify.theme.themes[theme].background"    
                style="width: 100%;"
                hide-details
                autocomplete="disabled"
                placeholder="naam/email/telefoon"
                label="Vind een klant"
                prepend-inner-icon="search"
                :append-inner-icon="loaderSearch ? 'fas fa-circle-notch fa-spin' : ''"
                v-model="zoekSalonhubClient"
                clearable
                :disabled="type == 'view'"
              ></v-text-field>

              <div v-if="zoekSalonhubClient && zoekSalonhubClient.length > 2" class="searchResults">
                <v-card
                  style="position: absolute; width: 100%; z-index:99; max-height: 260px; overflow-y: scroll;"
                  class="mx-auto"
                  tile
                  >
                  <v-list v-for="(resultsSearch, index) in searchResultsSalonhub" :key="index"  two-line subtitle dense class="pa-0 ma-0">
                    <v-list-item @click="setClientData(resultsSearch), searchResultsSalonhub = [], zoekSalonhubClient = ''">
                      <v-list-item-avatar >
                        <v-icon class="my-0" style="background-color: #eee;">person</v-icon>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title>{{ resultsSearch.firstname }} {{ resultsSearch.middlename }} {{ resultsSearch.lastname }}</v-list-item-title>
                        <v-list-item-subtitle>{{resultsSearch.address}} <span style="color: rgba(0,0,0,0.54);" v-if="resultsSearch.address">{{resultsSearch.number}}, </span>{{resultsSearch.city}}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider v-if="index + 1 < searchResultsSalonhub.length"></v-divider> 
                  </v-list>

                </v-card>
              </div>
            </div>

            
            <v-container grid-list-sm class="ma-0 pa-2" fluid>
              <h3 class="pt-2">Contactgegegevens</h3>
              <v-layout row wrap>
                <v-flex md6 xs12>
                  <v-text-field
                    label="Voornaam"
                    v-model="newMedicalIntake.firstName"
                    :rules="requiredRules"
                    dense
                    outlined
                    required
                    :disabled="type == 'view' || client"
                  ></v-text-field>
                </v-flex>
                <v-flex md6 xs12>
                  <v-text-field
                    label="Achternaam"
                    v-model="newMedicalIntake.lastName"
                    :rules="requiredRules"
                    dense
                    outlined
                    required
                    :disabled="type == 'view' || client"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>

            <v-container grid-list-md class="ma-0 pa-0" >
              <h4 style="font-size: 18px; font-weight: bold" class="mb-2">Algemene voorwaarden</h4>
              <v-checkbox
                class="pa-0 ma-0"
                v-model="newMedicalIntake.agreeTermsAndConditions"
                label="Ik heb deze vragenlijst naar waarheid ingevuld."
                :disabled="type == 'view'"
              ></v-checkbox>

              <v-menu
                
                ref="dateDialog"
                :close-on-content-click="false"
                v-model="queueEndDateDialog"
                transition="scale-transition"
                max-width="290px"
                min-width="290px"
                >
                <template v-slot:activator="{on}">
                  <v-text-field
                    class="mt-4"
                    :color="companyPrimaryColor"
                    v-on="on"
                    outlined
                    dense
                    v-model="signDateFormatted"
                    label="Ondertekend op"
                    append-icon="today"
                    readonly
                    :disabled="type == 'view'"
                  ></v-text-field>
                </template>
                <v-date-picker
                  :color="companyPrimaryColor"
                  v-model="newMedicalIntake.signDate"
                  :min="today"
                  :show-current="true"
                  no-title
                  @input="queueEndDateDialog = false"
                ></v-date-picker>
              </v-menu>

              <v-select
                class="ma-1"
                dense
                outlined
                :color="companyPrimaryColor"
                :item-color="companyPrimaryColor"
                :items="branches"
                item-text="branchName"
                item-value="id"
                v-model="newMedicalIntake.branch"
                label="Plaats"
                hide-details
                :disabled="type == 'view'"
              ></v-select>

              <!-- <div style="padding: 10px 0 0 0;">
                <p v-if="deviatingAdvice.type == 'new'" style="font-size: 14px;"><strong>Datum:</strong> {{ deviatingAdvice.timestamp | moment(" D MMM YYYY - H:mm") }}u</p>
              </div> -->
                
              <v-layout row wrap class="ma-0 pa-0">
                <v-flex x12 v-if="type == 'add'">
                  <p class="pa-0 mb-1" style="font-size: 16px;"><strong>Handtekening</strong></p>
                  <vueSignature ref="signature" :sigOption="signatureOptions" :w="'100%'" :h="'140px'" style="border: 2px solid #333; border-radius: 8px; overflow: hidden"></vueSignature>
                  <v-btn small depressed class="my-2" @click="clearSignature">Wissen</v-btn> 
                </v-flex>
                <v-flex x12 v-else>
                  <v-img width="250px" :src="newMedicalIntake.clientSignature"></v-img>
                </v-flex>

              </v-layout>
            </v-container> 
          </div>

          <div v-if="step == 3" >
            <v-container grid-list-md class="ma-0 pa-2" fluid>
              <v-layout row wrap class="py-2">
                <v-flex xs12 class="text-center" style="padding:150px 0">
                  <h2>Geef de iPad weer terug aan de Hairextensions Professional</h2>
                  <p class="pt-3">Na de analyse van de professional wordt de haarconditie bepaald.</p>
                </v-flex>
              </v-layout>
            </v-container>
          </div>

          <div v-if="step == 4" >
            <v-container grid-list-md class="ma-0 pa-2" fluid>
              <v-layout row wrap class="py-2">
                <v-flex xs12>
                  <h2>Vragenlijst voor hairextensions professional</h2>
                  <p class="ma-0">Kijk goed naar het haar van de klant, stel je vragen en vul dan de volgende vragenlijst in:</p>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="py-2">
                <v-flex xs6>
                  <v-select
                    v-model="newMedicalIntake.analyse.implant"
                    :items="implantOptions"
                    item-text="name"
                    item-value="id"
                    label="Implant"
                    outlined
                    dense
                    required
                    hide-details
                    :rules="requiredRules"
                    :disabled="type == 'view'"
                  ></v-select> 
                </v-flex>
              </v-layout>
              <v-layout row wrap class="py-2">
                <v-flex xs6>
                  <v-select
                    v-model="newMedicalIntake.analyse.hairThickness"
                    :items="hairThicknessOptions"
                    item-text="name"
                    item-value="id"
                    label="Haardikte"
                    outlined
                    dense
                    required
                    hide-details
                    :rules="requiredRules"
                    :disabled="type == 'view'"
                  ></v-select> 
                </v-flex>
              </v-layout>
              <v-layout row wrap class="py-2">
                <v-flex xs12>
                  <h2>Poreus haar</h2>
                  <p>
                    <i>Pak één haartje aan de punt tussen je duim en wijsvinger vast, en glijd met je vingers van onder naar boven. Gaat dat soepel? Dan heeft het haar waarschijnlijk een lage porositeit. Voel je veel bobbeltjes? Dat zijn haarschubben, dus de kans is groot dat het haar erg poreus is.</i>
                  </p>
                </v-flex>
       
                <v-flex xs6>
                  <v-select
                    v-model="newMedicalIntake.analyse.porousHair"
                    :items="porousHairOptions"
                    item-text="name"
                    item-value="id"
                    label="Poreus haar?"
                    outlined
                    dense
                    required
                    hide-details
                    :rules="requiredRules"
                    :disabled="type == 'view'"
                  ></v-select> 
                </v-flex>
              </v-layout>

              <v-layout row wrap class="py-2">
                <v-flex xs12>
                  <h2>Aantal maanden draagtijd</h2>
                  <p>
                    <i>Vul hier het aantal maanden draagtijd in dat jij adviseert o.b.v. de inplant en dikte van het haar. Nieuwe klanten altijd 3 maanden adviseren!:</i>
                  </p>
                </v-flex>
       
                <v-flex xs6>
                  <v-select
                    v-model="newMedicalIntake.analyse.wearingTime"
                    :items="wearingTimeOptions"
                    item-text="name"
                    item-value="id"
                    label="Aantal maanden draagtijd"
                    outlined
                    dense
                    required
                    hide-details
                    :rules="requiredRules"
                    :disabled="type == 'view'"
                  ></v-select> 
                </v-flex>
              </v-layout>

              <v-layout row wrap class="py-2">
                <v-flex xs6>
                  <v-select
                    v-model="newMedicalIntake.analyse.brand"
                    :items="brandOptions"
                    item-text="name"
                    item-value="id"
                    label="Merk"
                    outlined
                    dense
                    required
                    hide-details
                    :rules="requiredRules"
                    :disabled="type == 'view'"
                  ></v-select> 
                </v-flex>
              </v-layout>
              <v-layout row wrap class="py-2">
                <v-flex xs6>
                  <v-select
                    v-if="newMedicalIntake.analyse.brand == 'hairloxx'"
                    v-model="newMedicalIntake.analyse.length"
                    :items="lengthHairloxxOptions"
                    item-text="name"
                    item-value="id"
                    label="Lengte"
                    outlined
                    dense
                    required
                    hide-details
                    :rules="requiredRules"
                    :disabled="type == 'view'"
                  ></v-select> 
                  <v-select
                    v-if="newMedicalIntake.analyse.brand == 'indianGold'"
                    v-model="newMedicalIntake.analyse.length"
                    :items="lengthIndianGoldOptions"
                    item-text="name"
                    item-value="id"
                    label="Lengte"
                    outlined
                    dense
                    required
                    hide-details
                    :rules="requiredRules"
                    :disabled="type == 'view'"
                  ></v-select> 
                </v-flex>
              </v-layout>

              <v-layout row wrap class="py-2">
                <v-flex xs6>
                  <v-text-field
                    label="Aantal extensions"
                    v-model="newMedicalIntake.analyse.numberExtensions"
                    :rules="requiredRules"
                    dense
                    persistent-hint
                    hint="Vul hier het aantal hairextensions in die je adviseert:"
                    outlined
                    required
                    :disabled="type == 'view'"
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout row wrap class="py-2">
                <v-flex xs12>
                  <h3>Hoe wilt de klant het kunnen dragen na de behandeling?</h3>
                </v-flex>
                <v-flex xs12>
                  <v-select
                    v-model="newMedicalIntake.analyse.wearingType"
                    :items="wearingTypeOptions"
                    item-text="name"
                    item-value="id"
                    outlined
                    chips
                    dense
                    multiple
                    required
                    hide-details
                    :rules="requiredRules"
                    :disabled="type == 'view'"
                  ></v-select> 
                </v-flex>
              </v-layout>
            </v-container>
          </div>

          <div v-if="step == 5" >

            <div class="pa-3 pb-0 mb-4" style="background-color: #f9f9f9">
              <h2>Uitkomst vragenlijst</h2>
              <div v-if="newMedicalIntake.feedback.questions.length > 0"  v-for="(feedback, index) in newMedicalIntake.feedback.questions" :key="index+ 9" class="py-2">
                  <span v-html="feedback"></span>
              </div>
              <div v-if="newMedicalIntake.feedback.questions.length == 0" class="py-2">
                <h3>Geen extra risico</h3>
              </div>
            </div>
            <div class="pa-3 pb-0 mb-4" style="background-color: #f9f9f9">
              <h2>Uitkomst analyse</h2>
              <div v-if="newMedicalIntake.feedback.analyse.length > 0"  v-for="(feedback, index) in newMedicalIntake.feedback.analyse" :key="index +6" class="py-2">
                  <span v-html="feedback"></span>
              </div>
              <div v-if="newMedicalIntake.feedback.analyse.length == 0" class="py-2">
                <h3>Geen extra bijzonderheden</h3>
              </div>
            </div>
          </div>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-container grid-list-md fluid class="ma-0 pa-0">
          <v-layout row wrap class="ma-0 pa-0">
            <v-flex xs12 md6 class="text-left" v-if="$vuetify.breakpoint.name != 'sm' && $vuetify.breakpoint.name != 'xs'">
              <v-btn
                v-if="step == 1"
                outlined
                depressed
                :disabled="uploading"
                color="#8B93A6"
                @click="closeAddMedicalIntakeDialog()"
                >
                Annuleren
              </v-btn>
              <v-btn
                v-if="step != 1"
                outlined
                depressed
                :disabled="uploading"
                color="#8B93A6"
                @click="goToPreview()"
                >
                Vorige
              </v-btn>
            </v-flex>
            <v-flex xs12 md6 class="text-right">
              <v-btn
                v-if="step < 5"
                outlined
                :disabled="uploading"
                depressed
                color="#8B93A6"
                @click="goToNext()"
                >
                Volgende
              </v-btn>
              <v-btn
                v-if="step == 5 && type == 'add'"
                :dark="!uploading"
                :disabled="uploading"
                rounded
                :block="$vuetify.breakpoint.name == 'sm' || $vuetify.breakpoint.name == 'xs'"
                :color="companySecondaryColor"
                @click="saveMedicalIntake()"
                >
                Haarconditie opslaan
                <v-icon right dark>chevron_right</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-actions>
        
    </v-card>
  </v-dialog>
</template>


<script>
import { bus } from "../../main";
import db from "../../firebase/init";
import firebase from "firebase/app";;
import axios from "axios";
import platform from 'platform'; 
import moment from 'moment';
import vueSignature from "vue-signature"
import { P } from "vue-tabs-component";


export default {
  name: "add-intake-form",
  props: ['activeCompData'],
  components: {
    vueSignature
  },
  data() {
    return {
      client: false,
      newMedicalIntake:{
        questions:{
          colorTimesYear: null,
          bleachedLastYear: null,
          recentWeightloss: null,
          stress: null,
          medicines: null,
          medicinHairloss: null,
          narcose: null,
          hormoneFluctuations: null,
          recentBirth: null,
          periodGiveBirth: 'noPregnancy',
          boldness: null,
          diseases: null,
          corona: null,
          age: null,
        },
        analyse:{
          implant: null,
          hairThickness: null,
          porousHair: null,
          wearingTime: null,
          brand: 'hairloxx',
          length: null,
          numberExtensions: null,
          wearingType: null,
          vega: null
        },
        
        salonhubId: null,
        agreeTermsAndConditions: false,
        firstName: "",
        lastName: "",
        branch: "",
        signDate: " ",
        feedback: {
          questions: new Array(),
          analyse: new Array()
        }
      },
      type: "add",
      wearingTimeOptions: [
        {
          id: "lessThanThreeMonths",
          name: "< 3 maanden"
        },
        {
          id: "threeMonths",
          name: "3 maanden"
        },
        {
          id: "fourMonths",
          name: "4 maanden"
        }
      ],
      brandOptions: [
        {
          id: "hairloxx",
          name: "Hairloxx",
        },
        {
          id: "indianGold",
          name: "Indian Gold",
        }
      ],
      lengthHairloxxOptions: [
        {
          id: "35-40",
          name: "35/40 cm",
        },
        {
          id: "55-60",
          name: "55/60 cm",
        }
      ],
      lengthIndianGoldOptions: [
        {
          id: "30",
          name: "30 cm",
        },
        {
          id: "40",
          name: "40 cm",
        },
        {
          id: "50",
          name: "50 cm",
        }
      ],
      wearingTypeOptions: [
        {
          id: "looseHair",
          name: "Draagt het altijd los",
        },
        {
          id: "lowTail",
          name: "Lage staart",
        },
        {
          id: "highTail",
          name: "Hoge staart",
        },
        {
          id: "KnotUpdo",
          name: "Knot/opgestoken",
        },
        {
          id: "sunglassesInHair",
          name: "Zonnebril in het haar",
        },
        {
          id: "partingHair",
          name: "Draagt de scheiding naar rechts/links/midden",
        },
      ],
      ageOptions: [
        {
          id: "<50",
          name: "Jonger dan 50"
        },
        {
          id: ">=50",
          name: "50 of ouder"
        }
      ],
      implantOptions: [
        {
          id: "thin",
          name: "Dun"
        },
        {
          id: "medium",
          name: "Medium"
        },
        {
          id: "thick",
          name: "Dik"
        }
      ],
      hairThicknessOptions: [
        {
          id: "thin",
          name: "Dun"
        },
        {
          id: "medium",
          name: "Medium"
        },
        {
          id: "thick",
          name: "Dik"
        }
      ],
      porousHairOptions: [
        {
          id: "porous",
          name: "Poreus"
        },
        {
          id: "notPorous",
          name: "Niet poreus"
        }
      ],
      periodGiveBirthOptions: [
      {
          id: "noPregnancy",
          name: "Niet zwanger"
        },
        {
          id: "<3",
          name: "Binnen 3 maanden"
        },
        {
          id: ">3",
          name: "Later dan 3 maanden"
        }
      ],
      colorTimesYear: [
        {
          id: ">=8",
          name: "8 keer of meer"
        },
        {
          id: "<8",
          name: "Minder dan 8 keer"
        }
      ],


      selectedFromDossier: false,
      valid: false,
      step: 1,
      loaderSearch: false,
      zoekSalonhubClient: null,


      signatureOptions: {
        backgroundColor: '#eeeeee',
      },
      branches: new Array(),
      queueEndDateDialog: false,
      requiredRules: [v => !!v || "Dit veld is verplicht"],

      today: null,
      emailRules: [
        v => !!v || "E-mail is verplicht",
        v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || "E-mail must be valid"
      ],
      feedback: null,
      dialog: false,
      uploading: false,
      uploadProgress: 0,
      searchResultsSalonhub: new Array(),
      idFile: null,
      cardFile: null,
      idFilename: null,
      cardFilename: null,
      idImage: null,
      cardImage: null
    };
  },

  created(){
    bus.$on("openMedicalIntakeDialog", (client, type, item) =>{
      if(client){
        this.newMedicalIntake.salonhubId = Number(client.id);
        this.newMedicalIntake.firstName = client.firstname;
        this.newMedicalIntake.lastName = client.middlename + " " + client.lastname;
        this.client = true;
      }
      else{
        this.client = false;
      }

      this.type = type ? type : "add";

      if(type && type == "view" && item){
        this.newMedicalIntake = item;
      }

      this.loadBranches(),
      this.newMedicalIntake.signDate = moment().format("YYYY-MM-DD");
      this.dialog = true;
    });
  },

  methods: {
    closeAddMedicalIntakeDialog() {
      this.dialog = false;
      this.step = 1;
      this.selectedFromDossier = false;

      this.newMedicalIntake = {
        questions:{
          colorTimesYear: null,
          bleachedLastYear: null,
          recentWeightloss: null,
          stress: null,
          medicines: null,
          medicinHairloss: null,
          narcose: null,
          hormoneFluctuations: null,
          recentBirth: null,
          periodGiveBirth: 'noPregnancy',
          boldness: null,
          diseases: null,
          corona: null,
          age: null,
        },
        analyse:{
          implant: null,
          hairThickness: null,
          porousHair: null
        },
        
        salonhubId: null,
        agreeTermsAndConditions: false,
        firstName: "",
        lastName: "",
        branch: "",
        signDate: " ",
        feedback: {
          questions: new Array(),
          analyse: new Array()
        }
      }
    },

    loadBranches() {
      this.branches = new Array();
      this.newMedicalIntake.branch = null;
      db.collection("branches")
      .where("compId", "==", this.activeCompData.id)
      .get()
      .then(snap => {
        snap.forEach(doc => {
          let branchCollection = doc.data();
          branchCollection.id = doc.id;
          this.branches.push(branchCollection);
        });
      })
      .then(()=>{
        this.newMedicalIntake.branch = this.branches[0].id;
      })
    },

    setClientData(resultsSearch){
      this.newMedicalIntake.firstName = resultsSearch.firstname;
      this.newMedicalIntake.lastName = resultsSearch.middlename + " " + resultsSearch.lastname;
      this.newMedicalIntake.salonhubId = resultsSearch.id;
    },

    clearSignature(){
      this.$refs.signature.clear();
    },

    goToPreview(){
      this.step--;
    },

    goToNext(){
      this.feedback = null;
  
      if(this.step == 1){ // Invullen vragenlijst
        if(this.newMedicalIntake.questions.colorTimesYear && this.newMedicalIntake.questions.bleachedLastYear && this.newMedicalIntake.questions.recentWeightloss && this.newMedicalIntake.questions.stress &&
        this.newMedicalIntake.questions.medicines && this.newMedicalIntake.questions.medicinHairloss && this.newMedicalIntake.questions.narcose && this.newMedicalIntake.questions.hormoneFluctuations &&
        this.newMedicalIntake.questions.recentBirth && this.newMedicalIntake.questions.periodGiveBirth && this.newMedicalIntake.questions.boldness && this.newMedicalIntake.questions.diseases && this.newMedicalIntake.questions.corona && this.newMedicalIntake.questions.age){
          this.step = 2;
        }
        else{
          this.feedback = "Vul alle velden in om door te gaan";
        }
      }
      else if(this.step == 2){ // Invullen gegevens
        let firstName = this.newMedicalIntake.firstName ? true : false;
        let lastName = this.newMedicalIntake.lastName ? true : false;
        let signDate = this.newMedicalIntake.signDate ? true : false;
        let agreeTermsAndConditions = this.newMedicalIntake.agreeTermsAndConditions ? true : false;
        let signature = false;
        if(this.type == "add"){
          signature = !this.$refs.signature.isEmpty() ? true : false;
        }

        if((firstName && lastName && signDate && agreeTermsAndConditions && signature) || this.type == 'view'){
          if(this.type == "add"){
            this.newMedicalIntake.clientSignature = this.$refs.signature.save();
          }
          this.step = 3;
        }
        else{
          this.feedback = "Vul alle gegevens in om door te gaan.";
        }
      }
      else if(this.step == 3){ // Geeft de iPad terug aan de professional
        this.step = 4;
      }
      else if(this.step == 4){ // Analyse professional
        if(this.newMedicalIntake.analyse.porousHair && this.newMedicalIntake.analyse.hairThickness && this.newMedicalIntake.analyse.numberExtensions && this.newMedicalIntake.analyse.wearingTime && this.newMedicalIntake.analyse.brand && this.newMedicalIntake.analyse.wearingType){
          this.newMedicalIntake.feedback.questions = new Array();
          this.newMedicalIntake.feedback.analyse = new Array();
          let risk = 0
          let medicalFeedback = "";
          let ageFeedback = "";
          let riskQuestions = new Array();

          let oneTwoFifteen = 0;

          if(this.newMedicalIntake.questions.colorTimesYear == ">=8"){ risk++; oneTwoFifteen++}
          if(this.newMedicalIntake.questions.bleachedLastYear == "yes"){ risk++; oneTwoFifteen++}
          if(this.newMedicalIntake.questions.recentWeightloss == "yes"){ risk++;  riskQuestions.push(3)}
          if(this.newMedicalIntake.questions.stress == "yes"){ risk++;  riskQuestions.push(4)}
          if(this.newMedicalIntake.questions.medicines == "yes" && this.newMedicalIntake.questions.medicinHairloss == "yes"){ risk++;  riskQuestions.push(5); riskQuestions.push(6)}
          if(this.newMedicalIntake.questions.narcose == "yes"){ risk++;  riskQuestions.push(7)}
          if(this.newMedicalIntake.questions.recentBirth == "yes"){ risk++;  riskQuestions.push(8)}
          if(this.newMedicalIntake.questions.periodGiveBirth == "<3"){ risk++;  riskQuestions.push(9)}
          if(this.newMedicalIntake.questions.hormoneFluctuations == "yes"){ risk++;  riskQuestions.push(10)}
          if(this.newMedicalIntake.questions.boldness == "yes"){ risk++;  riskQuestions.push(11)}
          if(this.newMedicalIntake.questions.diseases == "yes"){ risk++;  riskQuestions.push(12)}
          if(this.newMedicalIntake.questions.corona == "yes"){ risk++;  riskQuestions.push(13)}
          if(this.newMedicalIntake.questions.vega == "yes"){ risk++;  oneTwoFifteen++}

          risk = risk - oneTwoFifteen;

          if(risk == 1){
            if(riskQuestions[0] == 4 || riskQuestions[0] == 5 || (riskQuestions[0] > 8 && riskQuestions[0] < 15)){
              medicalFeedback = `<h3>Licht verhoogd risico </h3><p>Je hebt een licht verhoogd risico op haaruitval. 
                Dit risico komt door <span class="medical-question-collapse">vraag ${riskQuestions.toString()}
                  <span class="medical-question-collapsed-wrapper">
                    ${this.formatRiskQuestions(riskQuestions)}
                  </span>
                </span>.   
                Als je haaruitval krijgt tijdens het dragen van hairextensions, dan kunnen de hairextensions aan te dunne plukjes komen te hangen. Dit risico is heel klein in jouw geval. We willen wel je graag vragen op te letten. Heb je het idee dat je plukjes sneller dan 3 maanden gaan trekken of dat je meer haaruitval hebt dan normaal, dan kun je ons bellen voor een check-up afspraak, zodat we je kwaliteit van je haar en de hairextensions kunnen controleren.</p>`;
              this.newMedicalIntake.feedback.questions.push(medicalFeedback);
            }

            if(riskQuestions.includes(3) || riskQuestions.includes(6) || riskQuestions.includes(7) || riskQuestions.includes(8)){
              medicalFeedback = `<h3>Verhoogd risico </h3><p>Je hebt een verhoogd risico op haaruitval of afbrekend haar. Dit risico komt door vragen 3, 6, 7 of 8. Wij vragen iedereen die ja heeft geantwoord op 1 van deze vragen om na <strong>6 weken na de behandeling 1 keer op een check-up</strong> komt zodat we je kwaliteit van je haar en de hairextensions kunnen controleren. De hairextensions kunnen aan te dunne plukjes komen te hangen bij overmatig haaruitval. Bij een check-up kunnen we tussentijds kijken wat de kwaliteit van je haar en hairextensions is</p>`;
              this.newMedicalIntake.feedback.questions.push(medicalFeedback);
            }
            
            // let number = null;
            // if(this.newMedicalIntake.questions.stress == "yes"){}
            // let medicines = this.newMedicalIntake.questions.medicines == "yes" ? true : false;
            // let medicines = this.newMedicalIntake.questions.medicines == "yes" ? true : false;


            // medicalFeedback = `<h3>Licht verhoogd risico </h3><p>Je hebt een licht verhoogd risico op haaruitval of afbrekend haar. Dit risico komt door vraag ${riskQuestions.toString()}. 
            // Als je haaruitval krijgt tijdens het dragen van hairextensions, dan kunnen de hairextensions aan te dunne plukjes komen te hangen. Dit risico is heel klein in jouw geval. 
            // We willen wel graag dat je <strong>na 4 weken na de behandeling 1 keer op een check-up</strong> komt zodat we je kwaliteit van je haar en de hairextensions kunnen controleren.</p>`;
            // this.newMedicalIntake.feedback.questions.push(medicalFeedback);
          }
          // if(risk == 2){
          //   medicalFeedback = `<h3>Verhoogd risico </h3><p>Je hebt een verhoogd risico op haaruitval of afbrekend haar. Dit risico komt door vragen ${riskQuestions.toString().replace(',', ' en ')}. Als je haaruitval krijgt tijdens het dragen van hairextensions, dan kunnen de hairextensions aan te dunne plukjes komen te hangen. 
          //   We willen graag dat je na de behandeling <strong>2 keer op een check-up</strong> komt zodat we je kwaliteit kunnen blijven controleren.</p>`;
          //   this.newMedicalIntake.feedback.questions.push(medicalFeedback);
          // }
          if(risk == 2 || risk == 3){
              medicalFeedback = `<h3>Verhoogd risico </h3><p>Je hebt een verhoogd risico op haaruitval of afbrekend haar. Dit risico komt door  
                <span class="medical-question-collapse">vragen ${ riskQuestions.toString() }
                  <span class="medical-question-collapsed-wrapper">
                    ${this.formatRiskQuestions(riskQuestions)}
                  </span>
                </span>. 
                Als je haaruitval krijgt tijdens het dragen van hairextensions, dan kunnen de hairextensions aan te dunne plukjes komen te hangen. We willen graag dat je na de behandeling <strong>1 keer op een check-up</strong> komt zodat we je kwaliteit kunnen blijven controleren na 6 weken.</p>`;
              this.newMedicalIntake.feedback.questions.push(medicalFeedback);
       
          }
          if(risk > 3){
            // medicalFeedback = `<h3>Hoog risico </h3><p>Je hebt een te hoog risico op haaruitval of afbrekend haar. We kunnen je nu <strong><u>niet</u> behandelen</strong>. 
            // Als je haaruitval krijgt tijdens het dragen van hairextensions, dan kunnen de hairextensions aan te dunne plukjes komen te hangen. Dit kan schade veroorzaken. Wij willen graag samen met je over 3 maanden weer kijken of het dan wel mogelijk is.</p>`;
            // this.newMedicalIntake.feedback.questions.push(medicalFeedback);
         
            // medicalFeedback = `<h3>Te hoog risico </h3><p>Je hebt een te hoog risico op haaruitval of afbrekend haar. We kunnen je nu <strong><u>niet</u> behandelen</strong>. Als je haaruitval krijgt tijdens het dragen van hairextensions, dan kunnen de hairextensions aan te dunne plukjes komen te hangen. Dit kan schade veroorzaken. Wij willen graag samen met je over 3 maanden weer kijken of het dan wel mogelijk is.</p>`;
            
            medicalFeedback =  `<h3>Te hoog risico</h3>
            <p>Je hebt een te hoog risico op haaruitval of afbrekend haar. Er zijn 2 mogelijkheden (kijk goed naar de gezondheid van het haar van de klant):<br>
              <ul class="medical-list">
                <li>
                  We kunnen je nu <strong><u>niet</u> behandelen</strong>. Als je haaruitval krijgt tijdens het dragen van
                  hairextensions, dan kunnen de hairextensions aan te dunne plukjes komen te hangen. Dit
                  kan schade veroorzaken. Wij willen graag samen met je over 3 maanden weer kijken of het
                  dan wel mogelijk is.
                </li>
                <li>
                  <strong>Ik adviseer een volumebehandeling met miniextensions, de Sensitive Volume Lift</strong>. Dit is
                  beter geschikt voor jouw haar. We willen wel graag dat je na de behandeling <strong>1 keer op een
                  check-up</strong> komt zodat we je kwaliteit kunnen blijven controleren na 6 weken.
                </li>
              </ul>
            </p>`;
            this.newMedicalIntake.feedback.questions.push(medicalFeedback);
          }

          if(this.newMedicalIntake.questions.vega == "yes"){
            medicalFeedback = `<h3>Vegetarisch of veganistisch</h3><p>Je bent vegetarisch of veganistisch. Het is daarmee belangrijk om voldoende Vitamine B12 bij te slikken. Een tekort aan vitamine B12 kan invloed hebben op de kwaliteit van je eigen haar.</p>`;
            this.newMedicalIntake.feedback.questions.push(medicalFeedback);
          }

          if(this.newMedicalIntake.questions.age == ">=50"){
            ageFeedback = `<h3>Leeftijd</h3><p>Wij vragen iedereen die boven de 50 jaar is om <strong>na 6 weken na de behandeling 1 keer op een check-up</strong> komt zodat we je kwaliteit van je haar en de hairextensions kunnen controleren. Omdat je eigen haar dunner kan worden door je leeftijd, kunnen de hairextensions aan te dunne plukjes komen te hangen. Bij een check-up kunnen we tussentijds kijken wat de kwaliteit van je haar en hairextensions is.</p>`
            this.newMedicalIntake.feedback.questions.push(ageFeedback);
          }

          if(this.newMedicalIntake.analyse.implant == 'tight'){
            let porousHairFeedback = "<h3>Implant:</h3><p>Je hebt een dunne implant. Dit is geen enkel probleem voor het inzetten van de hairextensions. Ik maak wel graag even een foto van je implant voor ons dossier.</p>";
            this.newMedicalIntake.feedback.analyse.push(porousHairFeedback);
          }
          if(this.newMedicalIntake.analyse.hairThickness == 'thin'){
            let porousHairFeedback = "<h3>Dun haar:</h3><p>Je hebt dun haar. Dit is geen enkel probleem voor het inzetten van de hairextensions. Ik wil je er wel op wijzen dat dun haar makkelijker slijt dan dik haar. Pas daarom goed op met het stylen van je haar. Ga niet overmatig stylen en gebruik een stylingtool die niet heter stylt dan 180 graden.</p>";
            this.newMedicalIntake.feedback.analyse.push(porousHairFeedback);
          }
          if(this.newMedicalIntake.analyse.porousHair == 'porous'){
            let porousHairFeedback = "<h3>Poreus haar:</h3><p>Je hebt poreus en/of vaak geverfd en/of geblondeerd haar. Dit is geen enkel probleem voor het inzetten van de hairextensions. (Vaak verven of blonderen maakt je haar wel poreuzer.) Ik wil je er wel op wijzen dat poreuzer haar makkelijker slijt. Pas daarom goed op met het stylen van je haar. Ga niet overmatig stylen en gebruik een stylingtool die niet heter stylt dan 180 graden. Gebruik ook altijd een heatprotector.</p>";
            this.newMedicalIntake.feedback.analyse.push(porousHairFeedback);
          }


          this.step = 5;
        }
        else{
          this.feedback = "Vul alle velden in om door te gaan.";
        }
      }
    },

    formatRiskQuestions(questions){
      let questionsFormat = "";

      questions.forEach(question=>{
        if(question == 1){ questionsFormat = questionsFormat +  "<span class='medical-question-item'>1. Hoe vaak kleur je helemaal je haar per jaar?</span>"}
        if(question == 2){ questionsFormat = questionsFormat +  "<span class='medical-question-item'>2. Heb je het afgelopen jaar je haar geblondeerd?</span>"}
        if(question == 3){ questionsFormat = questionsFormat +  "<span class='medical-question-item'>3. Ben je de laatste 3 maanden meer dan 10 kilo afgevallen? Of ben je momenteel op dieet of doe je aan intermittent fasting?</span>"}
        if(question == 4){ questionsFormat = questionsFormat +  "<span class='medical-question-item'>4. Ervaar je momenteel meer stress dan normaal?</span>"}
        if(question == 5){ questionsFormat = questionsFormat +  "<span class='medical-question-item'>5. Ben je de laatste 3 maanden medicijnen gaan gebruiken? Of ga je binnenkort medicijnen gebruiken?</span>"}
        if(question == 6){ questionsFormat = questionsFormat +  "<span class='medical-question-item'>6. Hebben deze medicijnen haarverlies als bijwerking?</span>"}
        if(question == 7){ questionsFormat = questionsFormat +  "<span class='medical-question-item'>7. Ben je recent onder narcose geweest?</span>"}
        if(question == 8){ questionsFormat = questionsFormat +  "<span class='medical-question-item'>8. Ben je net bevallen of gestopt met het geven borstvoeding?</span>"}
        if(question == 9){ questionsFormat = questionsFormat +  "<span class='medical-question-item'>9. Indien je nu zwanger bent, wanneer is je uitgerekende datum?</span>"}
        if(question == 10){ questionsFormat = questionsFormat +  "<span class='medical-question-item'>10. Heb je de laatste 3 maanden last van andere hormoonschommelingen gehad: zoals een verandering in je anticonceptie, menopauze of hormonenkuur?</span>"}
        if(question == 11){ questionsFormat = questionsFormat +  "<span class='medical-question-item'>11. Heb je in het verleden last gehad van zichtbaar haaruitval of kaalheid?</span>"}
        if(question == 12){ questionsFormat = questionsFormat +  "<span class='medical-question-item'>12. Lijd je aan één van de volgende haar aandoeningen of heb je daar in het verleden last van gehad: Alopecia androgenetica, Alopecia areata, Telogeen effluvium.</span>"}
        if(question == 13){ questionsFormat = questionsFormat +  "<span class='medical-question-item'>13. Heb je het afgelopen half jaar haaruitval door Corona gehad?</span>"}
        if(question == 14){ questionsFormat = questionsFormat +  "<span class='medical-question-item'>14. Hoe oud ben je?</span>"}
        if(question == 15){ questionsFormat = questionsFormat +  "<span class='medical-question-item'>15. Ben vegetarisch of veganistisch?</span>"}
      })
      
      return questionsFormat
    },





    getClientDataById(id){
      const urlCustomerId = `https://public.salonhub.nl/current/${this.activeCompData.salonhubApiSettings.customer}/${this.activeCompData.salonhubApiSettings.username}/${this.activeCompData.salonhubApiSettings.md5}/salon/${this.activeCompData.salonhubApiSettings.salons[0].salonhubid}/getCustomer?id=${encodeURI(id)}`
      fetch(urlCustomerId)
      .then(response => response.json())
      .then(data => {
        if(data){
          this.newMedicalIntake.firstName = data.firstname;
          this.newMedicalIntake.lastName = data.middlename + " " + data.lastname;
          this.newMedicalIntake.street = data.address + " " + data.number;
          this.newMedicalIntake.zipcode = data.postalcode;
          this.newMedicalIntake.city = data.city;
          this.newMedicalIntake.salonhubId = +data.id;
        }
      })
    },

    async saveMedicalIntake(){
      this.uploading = true;
      let fileUrls = {
        signatureUrl: null,
      };

      await new Promise((resolve, reject)=>{
        let counter = 0;
        let files = new Array();

        files = [
          {
            id: 'signature', 
            fileVar: 'signatureUrl', 
            field: 'clientSignature',
            url: this.activeCompData.id + "/" + "sign/" + this.activeCompData.id + "-" + moment().format("X")+ "intake-sign.png"
          },
        ];

        files.forEach(file => {
          let uploadTask = firebase.storage().ref(file.url).putString(this.newMedicalIntake[file.field].split(",")[1], "base64" );

          uploadTask.on(
            "state_changed",
            taskSnapshot => {},
            error => {
              console.log(error);
            }, () => {
              console.log("The upload is compleet:", file.id);
              uploadTask.snapshot.ref
              .getDownloadURL()
              .then(url => {
                fileUrls[file.fileVar] = url;
                counter++
                if(counter == files.length){
                  resolve()
                }
              })
              .catch(error => {
                reject(error)
              });
            }
          );
        });
      })
      
      db.collection("intakes").add({
        companyId: this.activeCompData.id,
        firstName: this.newMedicalIntake.firstName,
        lastName: this.newMedicalIntake.lastName,
        branch: this.newMedicalIntake.branch,
        salonhubId: this.newMedicalIntake.salonhubId ? +this.newMedicalIntake.salonhubId : null,
        dateAdded: new Date(),
        signDate: this.newMedicalIntake.signDate,
        clientSignature: fileUrls.signatureUrl,
        agreeTermsAndConditions: this.newMedicalIntake.agreeTermsAndConditions,
        questions: {
          colorTimesYear: this.newMedicalIntake.questions.colorTimesYear,
          bleachedLastYear: this.newMedicalIntake.questions.bleachedLastYear,
          recentWeightloss: this.newMedicalIntake.questions.recentWeightloss,
          stress: this.newMedicalIntake.questions.stress,
          medicines: this.newMedicalIntake.questions.medicines,
          medicinHairloss: this.newMedicalIntake.questions.medicinHairloss,
          narcose: this.newMedicalIntake.questions.narcose,
          hormoneFluctuations: this.newMedicalIntake.questions.hormoneFluctuations,
          recentBirth: this.newMedicalIntake.questions.recentBirth,
          periodGiveBirth: this.newMedicalIntake.questions.periodGiveBirth,
          boldness: this.newMedicalIntake.questions.boldness,
          diseases: this.newMedicalIntake.questions.diseases,
          corona: this.newMedicalIntake.questions.corona,
          age: this.newMedicalIntake.questions.age,
          vega: this.newMedicalIntake.questions.vega,
        },
        analyse:{
          porousHair: this.newMedicalIntake.analyse.porousHair,
          hairThickness: this.newMedicalIntake.analyse.hairThickness,
          porousHair: this.newMedicalIntake.analyse.porousHair,
          wearingTime: this.newMedicalIntake.analyse.wearingTime,
          brand: this.newMedicalIntake.analyse.brand,
          length: this.newMedicalIntake.analyse.length,
          numberExtensions: this.newMedicalIntake.analyse.numberExtensions,
          wearingType: this.newMedicalIntake.analyse.wearingType
        },
        feedback: {
          questions: this.newMedicalIntake.feedback.questions,
          analyse: this.newMedicalIntake.feedback.analyse,
        }
      })
      .then(()=>{
        this.uploading = false;
        this.closeAddMedicalIntakeDialog();
        this.$emit("updateData");
      })
      .catch(err => {
        this.feedback = "Fout bij opslaan. Probeer het opnieuw."
        console.error("Error adding document to membership", err);
      });
    },

    formatDate(date) {
      // Datum omvormen naar Europese leesbare datum
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}-${month}-${year}`;
    }
  },

  

   watch: {
    zoekSalonhubClient() {
      const url = `https://public.salonhub.nl/current/${this.activeCompData.salonhubApiSettings.customer}/${this.activeCompData.salonhubApiSettings.username}/${this.activeCompData.salonhubApiSettings.md5}/salon/${this.activeCompData.salonhubApiSettings.salons[0].salonhubid}/searchCustomer?salon=*&query=${encodeURI(this.zoekSalonhubClient)}`
      const urlCustomerId = `https://public.salonhub.nl/current/${this.activeCompData.salonhubApiSettings.customer}/${this.activeCompData.salonhubApiSettings.username}/${this.activeCompData.salonhubApiSettings.md5}/salon/${this.activeCompData.salonhubApiSettings.salons[0].salonhubid}/getCustomer?id=${encodeURI(this.zoekSalonhubClient)}`
    
      return new Promise(resolve => {
        let counter = 0;
        if (!this.zoekSalonhubClient || (this.zoekSalonhubClient && this.zoekSalonhubClient.length < 3)) {
          this.searchResultsSalonhub = [];
          return resolve([])
        } 
        else {
          this.searchResultsSalonhub = [];
          this.loaderSearch = true;
          fetch(url)
          .then(response => response.json())
          .then(data => {
            counter++
            if(counter == 2){
              resolve()
            }
            this.searchResultsSalonhub = data.slice(0,15)
          })
          fetch(urlCustomerId)
          .then(response => response.json())
          .then(data => {
            if(data){
              this.searchResultsSalonhub.unshift(data);
            }
            counter++
            if(counter == 2){
              resolve()
            }
          })
        } 
      })
      .then(()=>{
        this.loaderSearch = false
      })
    },
  },

  computed: {

    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
     theme(){
      return (this.$vuetify.theme.dark) ? 'dark' : 'light'
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
    signDateFormatted() {
      // Datum omvormen naar Europese leesbare datum
      return this.formatDate(this.newMedicalIntake.signDate);
    },
  }
};
</script>
<style>
.medical-list{
  list-style-type: square;
}
.number-list{
  list-style-type: number;
}
.medical-list li,
.number-list li{
  display: list-item;
}
.v-overlay__scrim,
.v-overlay.v-overlay--active{
  -webkit-backdrop-filter: blur(8px);
  backdrop-filter: blur(8px);
}


.medical-question-collapse{
  position: relative;
  padding: 0 15px 0 0;
  font-weight: bold;
}

.medical-question-collapse:after{
  display: block;
  content: "";
  position: absolute;
  right: 0;
  top: 3px;
  width: 15px;
  height: 15px;
  border: 7px solid black;
  border-left-color: transparent;
  border-right-color: transparent;
  border-bottom-color: transparent;
}
.medical-question-collapsed-wrapper{
  display: none;
}
.medical-question-collapse:hover .medical-question-collapsed-wrapper,
.medical-question-collapse:focus .medical-question-collapsed-wrapper{
  display: block;
  position: absolute;
  background-color: #ffffff;
  border-radius: 5px;
  overflow: hidden;
  display: block;
  width: 350px;
  box-shadow: 0px 0px 25px #999;
}


.medical-question-item{
  display: block;
  width: 100%;
  border-bottom: 1px solid #eee;
  padding: 3px 5px;
}

</style>
